import PropTypes from 'prop-types';
import { Field, Form, FormElement } from '@progress/kendo-react-form';
import { FormDropDownList } from 'commons/forms/form';
import { required } from 'commons/forms/validators';
import ConfirmationModal from 'commons/modal/ConfirmationModal';
import CustomModal from 'commons/modal/CustomModal';
import FormFooterWithAccess from 'commons/modal/FormFooterWithAccess';
import React, { useState } from 'react';
import { useGetDiffuseursQuery, useGetMediasQuery } from '../../../../redux/api/cache';

export default function CreateDiffuseurModal(props) {
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const { data: mediasDropDown } = useGetMediasQuery();
  const { data: diffuseurDropDown } = useGetDiffuseursQuery(props.media);

  const handleSubmit = (dataItem) => {
    let media = mediasDropDown?.data?.find(
      (item) => item.media_cd === dataItem.media
    ).media_cd;
    let diff = diffuseurDropDown?.data?.find(
      (item) => item.diff_nom === dataItem.diffuseur
    ).diff_cd;
    props.create({
      rid: props.selectedRow?.rid,
      diff_cd: diff,
      camp_seq: props.rowData.camp_seq,
      media_cd: media,
    });
    props.toggleDialog();
  };

  const mediaValidator = (e) => required(e, 'Média');
  const diffuseurValidator = (e) => required(e, 'Diffuseur');

  return (
    <div>
      <CustomModal
        width={'50%'}
        title="Diffuseur"
        onClose={props.toggleDialog}
        body={
          <Form
            initialValues={{
              media: mediasDropDown?.data?.find(
                (item) => item.media_cd === props.media
              )?.media_cd,
              diffuseur: diffuseurDropDown?.data?.find(
                (item) => item.diff_cd === props.selectedRow?.diff_cd
              )?.diff_nom,
            }}
            onSubmit={handleSubmit}
            render={(formRenderProps) => (
              <FormElement>
                <fieldset className={'k-form-fieldset'}>
                  <legend className={'k-form-legend'}>{`AJOUT D'UNE NOTE`}</legend>
                  <Field
                    disabled
                    id={'media'}
                    name={'media'}
                    label={'Média'}
                    data={mediasDropDown?.data?.map((item) => item.media_cd)}
                    component={FormDropDownList}
                    validator={mediaValidator} />
                  <Field
                    id={'diffuseur'}
                    name={'diffuseur'}
                    label={'Diffuseur'}
                    component={FormDropDownList}
                    data={diffuseurDropDown?.data?.map((item) => item.diff_nom)}
                    validator={diffuseurValidator} />
                  <FormFooterWithAccess
                    selectedRow={props.selectedRow}
                    formRenderProps={formRenderProps}
                    delete={() => {
                      setDeleteModalVisible(true);
                    }} />
                </fieldset>
              </FormElement>
            )
            }
          />
        }
      />
      {deleteModalVisible && (
        <ConfirmationModal
          text={'Confirmer la suppression du diffuseur ?'}
          onClose={() => {
            setDeleteModalVisible(false);
          }}
          onConfirm={() => {
            setDeleteModalVisible(false);
            props.toggleDialog();
            props.remove();
          }}
        />
      )}
    </div>
  );
}

CreateDiffuseurModal.propTypes = {
  create: PropTypes.func,
  media: PropTypes.string,
  remove: PropTypes.func,
  rowData: PropTypes.shape({
    camp_seq: PropTypes.any,
  }),
  selectedRow: PropTypes.shape({
    campmn_titre: PropTypes.any,
    diff_cd: PropTypes.any,
    rid: PropTypes.any,
  }),
  toggleDialog: PropTypes.func,
};
